/* CUSTOM form-hint.js — Code-Pille mit erklaerendem Tooltip (Apple-Stil).
 * Desktop: Hover zeigt den Tooltip (CSS). Touch (kein Hover): Tap oeffnet/schliesst
 * ihn — und navigiert dann NICHT zur PDP (die Pille sitzt im Titel-Link).
 */
(function () {
  if (customElements.get('form-hint')) return;

  const touchOnly = window.matchMedia('(hover: none)');

  class FormHint extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.form-hint__code');
      if (!this.trigger) return;

      this.trigger.addEventListener('click', (e) => {
        // Nur auf Touch-Geraeten als Tooltip-Toggle abfangen; auf Desktop normal (Hover zeigt Tooltip, Klick darf navigieren)
        if (touchOnly.matches) {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        }
      });
      this.trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); this.toggle(); }
      });
      this._onDocClick = (e) => { if (!this.contains(e.target)) this.close(); };
    }

    toggle() { this.classList.contains('is-open') ? this.close() : this.open(); }

    open() {
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this._onDocClick);
    }

    close() {
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this._onDocClick);
    }
  }

  customElements.define('form-hint', FormHint);
})();
